import { Link } from 'react-router-dom'

export function Privacy() {
  return (
    <div className="min-h-screen bg-black text-white">
      <div className="max-w-3xl mx-auto px-6 py-12">
        <div className="mb-8 flex items-center justify-between">
          <Link
            to="/"
            className="text-sm text-gray-400 hover:text-[#D4AF37] transition-colors"
          >
            &larr; Back to Home
          </Link>
          <span className="text-xs uppercase tracking-[0.2em] text-gray-500">
            Legal
          </span>
        </div>

        <h1 className="text-3xl md:text-4xl font-bold mb-4 bg-gradient-to-r from-[#D4AF37] to-[#FFD700] bg-clip-text text-transparent">
          Privacy Policy
        </h1>
        <p className="text-gray-400 mb-8">
          This Privacy Policy explains how Binyuma TV collects, uses, and protects your personal
          information when you use our website, application, and related services.
        </p>

        <div className="space-y-6 text-sm md:text-base leading-relaxed text-gray-300">
          <section>
            <h2 className="text-lg font-semibold text-white mb-2">
              1. Information We Collect
            </h2>
            <p>
              We collect information you provide directly to us, such as your name, email address,
              and account details, as well as information about how you use the Service, including
              the content you watch and your interactions with creators and other members.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-2">
              2. Age & Safety
            </h2>
            <p>
              Where required to apply age-based content restrictions, we may ask for your date of
              birth. We use this information solely to ensure that mature content is not shown to
              underage viewers and to comply with app store and regulatory requirements.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-2">
              3. How We Use Your Information
            </h2>
            <p>
              We use your information to operate and improve Binyuma TV, personalize your
              experience, provide customer support, communicate with you about updates or offers,
              and to keep the Service safe and secure.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-2">
              4. Sharing of Information
            </h2>
            <p>
              We may share limited information with trusted service providers who help us host,
              analyze, or deliver the Service. These providers are required to protect your
              information and may not use it for their own independent purposes.
            </p>
            <p className="mt-2">
              We may also share information when required by law, to protect our rights or the
              safety of users, or in connection with a corporate transaction.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-2">
              5. Your Choices
            </h2>
            <p>
              Where available under local law, you may have rights to access, correct, or delete
              certain personal information we hold about you, or to object to certain uses of your
              data. You can also manage some privacy-related settings directly in the app.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-2">
              6. Changes to This Policy
            </h2>
            <p>
              We may update this Privacy Policy from time to time. When changes are material, we
              will provide reasonable notice within the app, on the website, or via email where
              appropriate. Continued use of the Service after updates become effective constitutes
              acceptance of the revised Policy.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-2">
              7. Contact
            </h2>
            <p>
              If you have questions about this Privacy Policy or how we handle your information,
              please contact us using the support information provided in the app or on our
              website.
            </p>
          </section>
        </div>
      </div>
    </div>
  )
}
